import React from "react";
import styled from "styled-components";
import { IconX } from "@upsolve/ui";

const Z_OVERLAY_BACKDROP = 999;
type TViewportCenteredFixed = {
  zIndex?: string;
};

export const ViewportCenteredFixed = styled.div<TViewportCenteredFixed>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${({ zIndex }) => zIndex ?? Z_OVERLAY_BACKDROP + 1};
`;

export const ModalHeader = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  padding: 0.75em 1em 0.5em;
  border-bottom: 1px solid ${(p) => p.theme.colors.white[700]};
`;

const StyledModalClose = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
  height: 36px;
  width: 36px;
  border-radius: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(p) => p.theme.colors.white[700]};
  cursor: pointer;
  svg {
    height: 18px;
    width: 18px;
    path {
      fill: ${(p) => p.theme.colors.gray[800]};
    }
  }
  &:hover {
    background: ${(p) => p.theme.colors.white[500]};
  }
`;

export const ModalClose = (props: any) => (
  <StyledModalClose className="close-button" {...props}>
    <IconX />
  </StyledModalClose>
);
export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 0.5em;
  max-height: 80vh;
  overflow-y: auto;
`;

export const ModalActions = styled.div`
  display: flex;
  padding: 0 1em 1em;
  & > button {
    display: flex;
    width: 100%;
  }
`;

export const ModalFooter = styled.div`
  justify-content: center;
  align-items: center;
  text-align: center;
  background: ${(p) => p.theme.colors.white[700]};
  padding: 1em;
`;

export const StyledModal = styled.div<{ css?: any }>`
  width: 420px;
  background: white;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media (max-width: ${(p) => p.theme.breakpoints[500]}) {
    height: 100%;
    border-radius: 0;
  }
  ${(props) => {
    if (props.css) return props.css;
  }}
`;

// TODO: figure out the right way to type styled-components "css"
export const Modal: React.FC<{ css?: any }> = ({ children, css, ...props }) => {
  return (
    <StyledModal css={css} onClick={(e) => e.stopPropagation()} {...props}>
      {children}
    </StyledModal>
  );
};
